var map = {
	"./android.png": 2174,
	"./angular.png": 6105,
	"./aws.png": 388,
	"./c.png": 472,
	"./css3.png": 4807,
	"./docker.png": 4215,
	"./drawio.png": 5637,
	"./elixir.png": 370,
	"./express.png": 9015,
	"./figma.png": 335,
	"./github.png": 5590,
	"./gitlab.png": 6446,
	"./html5.png": 9283,
	"./java.png": 7827,
	"./javascript.png": 7666,
	"./linux.png": 7257,
	"./mariadb.png": 935,
	"./mongodb.png": 1317,
	"./mysql.png": 2193,
	"./node.png": 4247,
	"./php.png": 6059,
	"./postgresql.png": 1221,
	"./postman.png": 4593,
	"./python.png": 245,
	"./react.png": 3638,
	"./spring.png": 3252,
	"./vagrant.png": 5424,
	"./vuejs.png": 9734,
	"./windows.png": 2468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8964;